const COOKIE_NAME = "lbx_utm";
const UTM_KEYS = ["source", "medium", "campaign", "content", "term"];
const UTM_FIELD_PREFIX = "user-analytics-utm-";

function readStoredUtms() {
  const match = document.cookie.match(/(?:^|;\s*)lbx_utm=([^;]*)/);

  if (!match) {
    return {};
  }

  try {
    return JSON.parse(decodeURIComponent(match[1])) || {};
  } catch (error) {
    return {};
  }
}

function captureUtms() {
  const params = new URLSearchParams(window.location.search);
  const utms = {};

  UTM_KEYS.forEach((key) => {
    const value = params.get(`utm_${key}`);

    if (value) {
      utms[key] = value.slice(0, 200);
    }
  });

  if (!Object.keys(utms).length) {
    return readStoredUtms();
  }

  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(utms))}; path=/; SameSite=Lax${secure}`;

  return utms;
}

function fillAnalyticsFields(formModel, utms) {
  const containers = document.querySelectorAll(`#nf-form-${formModel.get("id")}-cont`);

  formModel.get("fields").each((field) => {
    const type = field.get("type") || "";
    let value = null;

    if (type === "user-analytics-referer") {
      value = document.referrer || "n/a";
    } else if (type.indexOf(UTM_FIELD_PREFIX) === 0) {
      const current = field.get("value");
      const stored = utms[type.slice(UTM_FIELD_PREFIX.length)];

      if (stored && (!current || current === "n/a")) {
        value = stored;
      }
    }

    if (value === null) {
      return;
    }

    field.set("value", value);

    containers.forEach((container) => {
      container.querySelectorAll(`.${type}-container .nf-element`).forEach((input) => {
        input.value = value;
      });
    });
  });
}

function safeFill(formModel, utms) {
  try {
    fillAnalyticsFields(formModel, utms);
  } catch (error) {
    console.error(error);
  }
}

export function initUtmAttribution() {
  const utms = captureUtms();
  let listeningSubmit = false;

  jQuery(document).on("nfFormReady", (event, layoutView) => {
    if (!listeningSubmit && window.nfRadio) {
      listeningSubmit = true;
      window.nfRadio.channel("forms").on("before:submit", (formModel) => safeFill(formModel, utms));
    }

    if (layoutView && layoutView.model) {
      safeFill(layoutView.model, utms);
    }
  });
}
